import { SVGProps } from 'react';

const WebhookOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3.976 3.976 0 0 1 2.57 15M9 3.4a4 4 0 0 1 6.52.66M6 17l3.1-5.8a2.5 2.5 0 0 0 .057-2.05M20.3 20.3a4 4 0 0 1-2.3.7m.6-8a4 4 0 0 1 3.357 3.414M12 6l.6 1M2 2l20 20"
    />
  </svg>
);
export default WebhookOff;
